export default {
  activeItemId: null,
  activeLMB: {
    bulbId: null,
  },
  activeModuleItemId: null,
  activePlaylistVideo: {
    bulbId: null,
    config: {},
    moduleId: null,
    name: '',
    scoreThreshold: 0,
  },
  activeResourceLinkURL: {},
  activeTextElement: {},
  adobePDFError: false,
  allBulbsInPlaylist: [],
  allModuleItemAttempts: [],
  alreadyCopied: null,
  badgrLoaded: false,
  credlyLoaded: false,
  certificateBadge: null,
  certificateMessage: null,
  certificateSignature: null,
  copiedPlaylistHash: false,
  courseCopy: false,
  courseHash: null,
  downloadResourceURL: null,
  editMode: false,
  hasPlaylistCertificateAccess: false,
  hasSchoolCertificateAccess: false,
  lastPDFPage: null,
  microcredentialService: 'None',
  nsf: false,
  PDFComplete: false,
  playlist: {},
  playlistAttempt: {},
  playlistClone: {},
  playlistDesignerKey: 0,
  playlistHasLMBs: false,
  playlistId: null,
  lmsConsumerVersion: '',
  lmsIssuer: '',
  isCompleted: false,
  isCreateLmbModalOpen: false,
  isProcessingData: false,
  isLoaded: false,
  isLti: false,
  lti13Launch: false,
  isUpdating: false,
  loadingData: false,
  moduleSelected: null,
  nextItem: {
    itemId: null,
  },
  nextItemToastTimeout: null,
  passbackBulbs: [],
  queryParams: {},
  requiredItemIndex: null,
  resourceLinkId: null,
  sectionId: null,
  settingsKey: 1,
  showSlideout: false,
  slideoutData: null,
  snackbar: {
    action: false,
    color: '',
    open: false,
    text: '',
    timeout: 3000,
  },
  studentSubmissionId: null,
  tags: {
    age: [],
    subject: [],
    keywords: [],
    rawData: [],
  },
  usedAttachmentIds: [],
  usedBulbIds: [],
  user: null,
  userToken: null,
};
